import React from "react";

// const CreateInvoice = React.lazy(() => import("./CreateInvoice"));
const CreateInvoice = React.lazy(() => import("./InvoiceCreate"));
const Index = React.lazy(() => import("./index"));
const InvoiceDetails = React.lazy(() => import("./InvoiceDetails"));

export const invoiceRoutes = [
	{
		path: "/admin/sellInvoices",
		name: "Sell Invoices",
		element: <Index />,
	},
	{
		path: "/admin/sellInvoices/create",
		name: "Create or Update Invoices",
		element: <CreateInvoice />,
	},
	{
		path: "/admin/sellInvoices/update/:id?",
		name: "Create or Update Invoices",
		element: <CreateInvoice />,
	},
	{
		path: "/admin/productInvoices/create",
		name: "Create or Update Product Invoices",
		element: <CreateInvoice />,
	},
	{
		path: "/admin/productInvoices/update/:id?",
		name: "Create or Update Product Invoices",
		element: <CreateInvoice />,
	},
	{
		path: "/admin/packageInvoices/(create|update)/:id?",
		name: "Create or Update Package Invoices",
		element: <CreateInvoice />,
	},
	{
		path: "/admin/sellInvoices/:id?",
		name: "Invoices",
		element: <InvoiceDetails />,
	},
];
